








































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import Header from "../components/header.vue";
import store from "../store";
import router from "../router";
import { client } from "@/api/index";
//import { CommonReq} from "@/pbjs/xcommon/module_pb";
import { localGet, setMetaData } from "@/utils/index";
import { setCommon, handleResponse, errorMsg } from "@/utils/request";
import { createCanvas as watermark } from "@/utils/watermark";
import { NxteleListReq } from "@/pbjs/xcommon/nxExtenManage_pb";
import {
  VerifyPasswordReq,
  ChangePasswordReq,
} from "@/pbjs/external/user/user_pb";
const QRCode = () => import("@/views/common/components/QRCode.vue");

//类组件@Component 必写
@Component({
  name: "system",
  components: { Header, QRCode },
})
export default class System extends Vue {
  // <!--temporary hidden-->
  @Provide() private lang: string = "English";
  @Provide() private breadList: string[] = [];
  @Provide() private client: any;
  @Provide() private num: number = 0;
  @Provide() private token: any;
  @Provide() private isTriggerMenu: boolean = true;
  @Provide() private userName: string = "";
  @Provide() private router: any;
  @Provide() private newrouter: any;
  @Provide() private txt: any = this.$t;
  @Provide() private qrCodeBase64: any = "";
  @Provide() private showDialogType: number = 0;
  @Provide() private qrCodeType: string = "myQrCode";
  @Provide() private showChangePwd: boolean = false; // 是否显示需改密码窗口
  @Provide() private oldPwd: any = ""; // 旧密码
  @Provide() private newPwd: any = ""; // 新密码
  @Provide() private repeatPwd: any = ""; // 确认密码
  @Provide() private isShowCN: boolean = true; // 是否展示汉语
  @Provide() private isInShow: boolean = true; // 印度只展示英文

  private created() {
    this.token = localGet("token");
    this.userName = localGet("userName");
    this.getBreadList();
    this.getLang(); // 獲取語言，防止刷新丟失
    // this.getTotalNum();
    this.router = this.$router;
    this.setMenuHiddenValue(this.router.options.routes[0].children);
    const menuList: any =
      localGet("menuList") && JSON.parse(localGet("menuList"));
    this.showMenu(this.router.options.routes[0].children, menuList);
    let country = localGet("country");
    if (country === "in") {
      this.isShowCN = false;
      this.isInShow = true;
    } else {
      this.isShowCN = true;
      this.isInShow = false;
    }
  }
  private mounted() {
    watermark();
    this.selfRightKeyboard();
  }

  private returnIsShow(type: number) {
    this.showDialogType = type;
  }

  public selfRightKeyboard() {
    let _menu: any = document.getElementById("menu");
    let _cont: any = Array.from(document.querySelectorAll(".subMenu"));
    let _openNewWindow: any = document.getElementById("openNewWindow");
    let _this = this;
    _cont.forEach((item: any) => {
      //点击鼠标右键
      item.oncontextmenu = function(ev: Event) {
        _menu.style.display = "block";
        //event--ie  ev--其他浏览器
        var oEvent: any = event || ev;
        _this.newrouter = oEvent.target.attributes["data-url"]["nodeValue"];
        //documentElement--其他游览器    body--谷歌
        var scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        //菜单的style样式跟随鼠标的位置
        _menu.style.top = oEvent.clientY + scrollTop + "px";
        var scrollLeft =
          document.documentElement.scrollLeft || document.body.scrollLeft;
        _menu.style.left = oEvent.clientX + scrollLeft + "px";
        //阻止系统默认的右键菜单
        return false;
      };
    });
    //点击页面，自定义菜单消失
    window.document.onclick = function() {
      _menu.style.display = "";
    };
    //点击跳转新窗口
    if (_openNewWindow) {
      _openNewWindow.onclick = function() {
        window.open(_this.newrouter);
      };
    }
  }
  public handleOpen() {}

  public handleClose() {
  }

  private triggerMenu() {
    this.isTriggerMenu = !this.isTriggerMenu;
  }

  private getLang() {
    if (localStorage.getItem("cn")) {
      let _val = localStorage.getItem("cn");
      if (_val === "zh-CN") {
        this.$i18n.locale = "zh-CN";
        this.lang = "中文";
      } else if (_val === "es-MX") {
        this.$i18n.locale = "es-MX";
        this.lang = "Español";
      } else if (_val === "en-US") {
        this.$i18n.locale = "en-US";
        this.lang = "English";
      } else if (_val === "vi-VN") {
        this.$i18n.locale = "vi-VN";
        this.lang = "Tiếng Việt";
      } else if (_val === "id-ID") {
        this.$i18n.locale = "id-ID";
        this.lang = "bahasa Indonesia";
      } else if (_val === "ar-AR") {
        this.$i18n.locale = "ar-AR";
        this.lang = " بالعربية ";
      }
    } else {
      // <!--temporary hidden-->
      this.lang = "English";
    }
  }
  private changeLang(val: string) {
    if (val === "cn") {
      this.$i18n.locale = "zh-CN";
      this.lang = "中文";
      localStorage.setItem("cn", "zh-CN");
    } else if (val === "es") {
      this.$i18n.locale = "es-MX";
      this.lang = "Español";
      localStorage.setItem("cn", "es-MX");
    } else if (val === "en") {
      this.$i18n.locale = "en-US";
      this.lang = "English";
      localStorage.setItem("cn", "en-US");
    } else if (val === "vi") {
      this.$i18n.locale = "vi-VN";
      this.lang = "Tiếng Việt";
      localStorage.setItem("cn", "vi-VN");
    } else if (val === "in") {
      this.$i18n.locale = "id-ID";
      this.lang = "bahasa Indonesia";
      localStorage.setItem("cn", "id-ID");
    } else if (val === "ar") {
      this.$i18n.locale = "ar-AR";
      this.lang = " بالعربية ";
      localStorage.setItem("cn", "ar-AR");
    }
    this.$router.go(0);
  }

  @Watch("$route")
  private getBreadList() {
    this.breadList = [];
    for (const routeInfo of this.$route.matched) {
      let name: string = routeInfo.meta.name;
      if (typeof name === "string") {
        this.breadList.push(this.$tc(name));
      }
    }
  }
  private logoutFuc(data: any) {
    this.$router.push("./login");
  }
  private logout() {
    let request: any = setCommon();
    client.logout(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.logoutFuc;
        handleResponse(data, _fuc);
        // if (!data.commonout || (data.commonout.code == 0)) {
        //     this.$router.push("./login");
        // } else {
        //     this.$message.error(data.commonout.errmsg);
        // }
      }
    });
  }

  private showMenu(data: any, returnData: any) {
    returnData.forEach((returnItem: any) => {
      data.forEach((item: any, index: number) => {
        if (returnItem.id == item.meta.id) {

          // this.$set(data[index].meta, 'hidden', false);
          // debugger;
          data[index].meta.hidden = false;
          if (returnItem.submenuList && item.children) {
            this.showMenu(item.children, returnItem.submenuList);
          }
        }
      });
    });
  }

  private setMenuHiddenValue(data: any) {
    data.forEach((item: any, index: number) => {
      if (item.meta) {
        data[index].meta.hidden = true;
      }
      if (item.children) {
        this.setMenuHiddenValue(item.children);
      }
    });
  }

  private myQR() {
    let myQRFunc: any = (data: any) => {
      this.qrCodeBase64 = data.qr;
      this.showDialogType = 1;
    };
    let request: any = setCommon();
    client.myQR(request, setMetaData(), (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        handleResponse(data, myQRFunc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  // 显示修改密码窗口
  showPwdToast() {
    this.showChangePwd = true;
  }
  // 修改密码
  private async changePwd() {
    let reg: any = /(^\s*)|(\s*$)/g;
    this.oldPwd = this.oldPwd.replace(reg, "");
    this.newPwd = this.newPwd.replace(reg, "");
    this.repeatPwd = this.repeatPwd.replace(reg, "");
    if (this.oldPwd == "") {
      this.$message({
        message: "oldPassword cannot be empty",
        type: "error",
      });
    } else {
      if (this.newPwd == "") {
        this.$message({
          message: "newPassword cannot be empty",
          type: "error",
        });
      } else {
        if (this.repeatPwd == "") {
          this.$message({
            message: "confirmPassword cannot be empty",
            type: "error",
          });
        } else {
          let regPwd = /[\S]{8,16}/;
          let flag1 = regPwd.test(this.oldPwd);
          let flag2 = regPwd.test(this.newPwd);
          let flag3 = regPwd.test(this.repeatPwd);
          if (flag1 && flag2 && flag3) {
            if (this.newPwd == this.repeatPwd) {
              let regName: any = new RegExp(this.userName, "g");
              if (!regName.test(this.newPwd)) {
                let res1: any = await this.verifyPwd();
                if (res1.code == 0) {
                  let res2: any = await this.changeNewPwd();
                  if (res2.code == 0) {
                    this.showChangePwd = false;
                    this.oldPwd = "";
                    this.newPwd = "";
                    this.repeatPwd = "";
                    this.$message({
                      message: "success",
                      type: "success",
                    });
                    this.$router.push("/login");
                  } else if (res2.code == 100115) {
                    this.$message({
                      message: this.$tc("authority.passwordRules"),
                      type: "error",
                    });
                  } else {
                    this.$message({
                      message: res2.errmsg,
                      type: "error",
                    });
                  }
                } else {
                  this.$message({
                    message: res1.errmsg,
                    type: "error",
                  });
                }
              } else {
                this.$message({
                  message: this.$tc("authority.passwordRules"),
                  type: "error",
                });
              }
            } else {
              this.$message({
                message: this.$tc("authority.disaccordWithThFirsPassword"),
                type: "error",
              });
            }
          } else {
            this.$message({
              message: this.$tc("authority.passwordRules"),
              type: "error",
            });
          }
        }
      }
    }
  }

  //修改新密码
  private changeNewPwd() {
    let that = this;
    return new Promise((resolve, reject) => {
      let request: any = new ChangePasswordReq();
      request.setCommonin(setCommon());
      request.setNewpassword(that.newPwd);
      client.changePassword(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            let data: any = response.toObject();
            let resp = handleResponse(data);
            resolve(resp);
          }
          if (err) {
            errorMsg(err);
          }
        }
      );
    });
  }
  // 校验旧密码是否正确
  private verifyPwd() {
    let that = this;
    return new Promise((resolve, reject) => {
      let request: any = new VerifyPasswordReq();
      request.setCommonin(setCommon());
      request.setPassword(that.oldPwd);
      client.verifyPassword(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            let data: any = response.toObject();
            resolve(data);
          }
          if (err) {
            errorMsg(err);
          }
        }
      );
    });
  }
  // 隐藏修改密码窗口
  private canclePwd() {
    this.showChangePwd = false;
    this.oldPwd = "";
    this.newPwd = "";
    this.repeatPwd = "";
  }
}
